import React from 'react'

import { ThemeProvider, makeStyles } from '@material-ui/core/styles'
import { CssBaseline, AppBar, Toolbar, Typography, Paper } from '@material-ui/core'

import theme from '../shared/theme'
import logo from '../shared/logo.png'

import ProvisioningWizard from './ProvisioningWizard'

const useStyles = makeStyles(({ spacing }) => ({
  stepper: {
    margin: `${spacing(15)}px auto`,
    width: 600,
    padding: spacing(2),
  },
  header: {
    marginLeft: spacing(3),
  },
}))

function App() {
  const classes = useStyles()

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppBar position="static" color="default">
        <Toolbar>
          <img src={logo} alt="BD company logo" />
          <Typography variant="h5" className={classes.header} color="primary">
            Provisioning
          </Typography>
        </Toolbar>
      </AppBar>

      <Paper className={classes.stepper}>
        <ProvisioningWizard />
      </Paper>
    </ThemeProvider>
  )
}

export default App
